// eslint-disable-next-line no-restricted-imports
import { useFormContext, UseFormReturn } from "react-hook-form";

export function useAppFormContext<Fields extends Record<string, any>>(): UseFormReturn<Fields> {
  return useFormContext();
}
